import { BLACK } from '../../utils/colors';

export const STROKE_STYLE = {
  stroke: BLACK,
  width: 2.5,
  opacity: 0.1,
};

export const CHART_TYPES = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const DEFAULT_SIZE = 250;
